import { Upload as UploadIcon } from '@mui/icons-material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';

interface Props {
  readonly clearAll: null | (() => void);
  readonly upload: null | (() => Promise<void>);
}

export function UploadActions(p: Props) {
  const { $t } = useIntl();

  return (
    <div>
      {p.upload && (
        <Button
          data-cy="upload"
          onClick={p.upload}
          sx={{ marginRight: 1 }}
          color="success"
          variant="contained"
          startIcon={<UploadIcon />}
        >
          {$t({
            id: 'audit.uploadScreen.upload',
            defaultMessage: 'Iniciar carga',
          })}
        </Button>
      )}
      {p.clearAll && (
        <Button
          data-cy="reset"
          onClick={p.clearAll}
          variant="outlined"
          color="secondary"
          startIcon={<RestartAltIcon />}
        >
          {$t({ id: 'audit.uploadScreen.reset', defaultMessage: 'Reiniciar' })}
        </Button>
      )}
    </div>
  );
}
